import React from 'react';

import { Control, useWatch } from 'react-hook-form';

import MarkdownPreview from '~/components/Common/MarkdownPreview';

import { TermsAndConditionsFormValues } from './types';

interface Props {
  control: Control<TermsAndConditionsFormValues>;
}

export default function BodyPreview({ control }: Props) {
  const body = useWatch({ control, name: 'body' });

  return <MarkdownPreview content={body ?? ''} />;
}
